import { Link } from 'react-router-dom';

import { bool, string } from 'prop-types';

import { Box, Card, CardContent, Typography } from '@mui/material';

import { useRetailerSettings } from '../hooks/useRetailerSettings';

const FlexCard = ({ url, label, image, externalLink, tag, description }) => {
  const { retailerSettings } = useRetailerSettings();

  const cardContent = (
    <Box sx={{ position: 'relative' }}>
      {/* Link Type Tag */}
      <Box
        sx={{
          position: 'absolute',
          top: -10,
          left: 16,
          backgroundColor: '#ff0081',
          color: '#fff',
          px: 2,
          py: 0.5,
          borderRadius: 0,
          fontSize: '0.75rem',
          fontWeight: 'bold',
          zIndex: 1,
        }}
      >
        {tag}
      </Box>
      
      <Card
        sx={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          height: '100%',
          // overflow: 'visible',
        }}
      >
        {/* Image Section */}
        <Box
          sx={{
            position: 'relative',
            backgroundImage: image ? `url(${image})` : 'none',
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundSize: "cover",
            height: "200px",
            // borderRadius: "12px 12px 0 0",
            backgroundColor: image ? 'transparent' : '#f0f0f0',
          }}
        />
        
        {/* Content Section */}
        <CardContent sx={{ p: 3 }}>
          <Typography
            variant='h3'
            sx={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: retailerSettings?.brand_color_2 || '#8B0000',
              textTransform: 'uppercase',
            }}
          >
            {label}
          </Typography>
          
          {description && (
            <Typography
              sx={{
                fontSize: '0.9rem',
                lineHeight: 1.6,
                color: '#333',
                mt: 2,
              }}
            >
              {description}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );

  return (
    <>
      { !!externalLink &&
        <a href={url}>
          {cardContent}
        </a>
      }
      { !!!externalLink &&
        <Link to={url}>
          {cardContent}
        </Link>
      }
    </>
  );
};

FlexCard.propTypes = {
  url: string.isRequired,
  label: string.isRequired,
  image: string,
  externalLink: bool,
  tag: string, // For the pink tag (RECIPES, PRODUCTS, etc.)
  description: string, // For the descriptive text below the heading
};

export default FlexCard;
